import DashboardTable from "./DashboardTable";
import DashboardNav from "./DashboardNav";

export { DashboardTable, DashboardNav };
export default DashboardTable;



// WEBPACK FOOTER //
// ./src/components/Dashboard/index.js